import {useCallback} from 'react';
import useUpdatePayinSessionMutation from 'src/api/graphql/useUpdatePayinSessionMutation';
import {getStore} from 'src/v2/state/store';

export const useMarkProcessing = () => {
  const store = getStore();
  const [updatePayinSession] = useUpdatePayinSessionMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  return useCallback(async () => {
    try {
      await updatePayinSession({
        variables: {
          input: {
            crypto_payin_session: sessionId,
            client_secret: clientSecret,
            mark_processing: true,
          },
        },
      });
    } finally {
      // Marking payment intent as processing is optional — if the API fails due to
      // a network error or transient server issue, it's still fine to transition state
      // because the processing screen polls for real status via usePaymentPollingAnyCrypto.
      store.setValue((state) => {
        state.screen = 'ANY_CRYPTO_PROGRESS';
      });
    }
  }, [sessionId, clientSecret, updatePayinSession, store]);
};
